module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("Planos "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Contrato 78426351 "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Histórico de contas "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Adesão e mensalidades")])], 1)]), _vm._v(" "), [_vm._m(0)], _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('router-link', {
    staticClass: "btn btn-back margin-t20",
    attrs: {
      "to": {
        name: 'plans'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n        Voltar\n      ")])], 1)])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-t20 table-white-header",
    staticStyle: {
      "min-height": "100px"
    }
  }, [_c('table', {
    staticClass: "table stripped-odd no-footer",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Período")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "47%"
    }
  }, [_vm._v("Tipo de transação")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%",
      "text-align": "right"
    }
  }, [_vm._v("Valor (R$)")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("01/01/2017")]), _vm._v(" "), _c('td', {
    staticClass: "cell-plate"
  }, [_c('div', [_vm._v("\n                AAA-9977\n              ")])]), _vm._v(" "), _c('td', [_vm._v("10 dias")]), _vm._v(" "), _c('td', [_vm._v("Mensalidade Move Mais")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("13,20")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("01/01/2017")]), _vm._v(" "), _c('td', {
    staticClass: "cell-plate"
  }, [_c('div', [_vm._v("\n                AAA-9977\n              ")])]), _vm._v(" "), _c('td', [_vm._v("10 dias")]), _vm._v(" "), _c('td', [_vm._v("Mensalidade Move Mais")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("13,20")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("01/01/2017")]), _vm._v(" "), _c('td', {
    staticClass: "cell-plate"
  }, [_c('div', [_vm._v("\n                AAA-9977\n              ")])]), _vm._v(" "), _c('td', [_vm._v("10 dias")]), _vm._v(" "), _c('td', [_vm._v("Mensalidade Move Mais")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("13,20")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("01/01/2017")]), _vm._v(" "), _c('td', {
    staticClass: "cell-plate"
  }, [_c('div', [_vm._v("\n                AAA-9977\n              ")])]), _vm._v(" "), _c('td', [_vm._v("10 dias")]), _vm._v(" "), _c('td', [_vm._v("Mensalidade Move Mais")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("13,20")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("01/01/2017")]), _vm._v(" "), _c('td', {
    staticClass: "cell-plate"
  }, [_c('div', [_vm._v("\n                AAA-9977\n              ")])]), _vm._v(" "), _c('td', [_vm._v("10 dias")]), _vm._v(" "), _c('td', [_vm._v("Mensalidade Move Mais")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("13,20")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-2fc5196d!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/accession-monthlypayment.vue
// module id = 2083
// module chunks = 1